import Vue from 'vue'
import 'vue2-animate/dist/vue2-animate.min.css';
import 'mint-ui/lib/style.css';
import App from './App'
import router from './router'
import axios from 'axios'
import axiosConfig from './service/config'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import store from './store';
import CryptoJS from 'crypto-js/crypto-js';
import ls from "./store/LStorage";
import params from './service/params';
import BScroll from 'better-scroll';
import scroll from 'vue-seamless-scroll';
import Swiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import infiniteScroll from 'vue-infinite-scroll';
import defalute from './assets/home/defalute.jpg'
Vue.use(scroll)
Vue.use(infiniteScroll)
Vue.use(MintUI);
Vue.use(Swiper)
Vue.prototype.$http = axios
Vue.prototype.$defaultImg = defalute;
Vue.config.productionTip = false
Vue.prototype.params = params
router.beforeEach((to, from, next) => {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS && to.path !== location.pathname) {
        location.assign(to.fullPath)
    } else {
        next()
    }
});
router.afterEach((to, from) => {
    if (to.path != '/contacts/reply') {
        window.scrollTo(0, 0)
    }
})
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js